var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "footerBox" }, [
    _c(
      "div",
      {
        staticClass: "footerItem",
        class: { active: _vm.active === "1" },
        on: {
          click: function($event) {
            _vm.to("")
          }
        }
      },
      [
        _c("div", { staticClass: "footerItemIcon f1" }),
        _vm._v("\n    首页\n  ")
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "footerItem",
        class: { active: _vm.active === "2" },
        on: {
          click: function($event) {
            _vm.to("ask")
          }
        }
      },
      [
        _c("div", { staticClass: "footerItemIcon f2" }),
        _vm._v("\n    咨询\n  ")
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "footerItem",
        class: { active: _vm.active === "3" },
        on: {
          click: function($event) {
            _vm.to("test")
          }
        }
      },
      [
        _c("div", { staticClass: "footerItemIcon f3" }),
        _vm._v("\n    测评\n  ")
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "footerItem",
        class: { active: _vm.active === "4" },
        on: {
          click: function($event) {
            _vm.to("my")
          }
        }
      },
      [
        _c("div", { staticClass: "footerItemIcon f4" }),
        _vm._v("\n    我的\n  ")
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6c4d8baa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c4d8baa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/footer.vue
// module id = null
// module chunks = 